<!-- Formulario para la carga y creacion de la empresa -->
<form [formGroup]="empresaForm">
    <h2 class="empresa_title-position font-weight-bold later-color title">
        Registro de empresa
    </h2>

    <div class="empresa_conteiner-form">
        <div class="empresa_conteiner-colum columna-izquierda">
            <!-- Bloque 1: Registrar o Asociar -->
            <div class="form-control empresa_Nit">
                <label class="text-label" for="nitRef">
                    1. Registrar o Asociar empresa
                    <sup class="text-danger">*</sup>
                </label>
                <select [formControl]="nitRef" (change)="changeSearch()">
                    <option value="Otro" [selected]="true">
                        1.1. Registro primera vez
                    </option>
                    <option value="">1.2. Nit empresa</option>
                </select>
                <div></div>
                <input
                    *ngIf="nitInputVisible"
                    type="text"
                    [formControl]="nitRef"
                    placeholder="Ingresa el NIT"
                    (change)="getCompany()" />
                <div *ngIf="withoutFinding" class="error-message error_nit">
                    Empresa no encontrada
                </div>
            </div>

            <div>
                <label class="text-label" for="tipoEmpresa">
                    2. Tipo de empresa:
                    <sup class="text-danger">*</sup>
                </label>
                <!-- Reutilizamos las clases de los otros apartados para mantener la consistencia visual -->
                <div class="container_tipo_producto">
                    <!-- Opción Persona Natural -->
                    <div class="eslabon-item">
                        <span>2.1 Persona Natural</span>
                        <button
                            class="btn_tipo btn_remove"
                            *ngIf="
                                empresaForm.get('tipoEmpresa').value !==
                                'Natural'
                            "
                            (click)="seleccionarTipoEmpresa('Natural')">
                            ▢
                        </button>
                        <button
                            class="btn_tipo btn_add"
                            *ngIf="
                                empresaForm.get('tipoEmpresa').value ===
                                'Natural'
                            "
                            (click)="seleccionarTipoEmpresa('Natural')">
                            ▣
                        </button>
                    </div>
                    <!-- Opción Persona Jurídica -->
                    <div class="eslabon-item">
                        <span>2.2 Persona Jurídica</span>
                        <button
                            class="btn_tipo btn_remove"
                            *ngIf="
                                empresaForm.get('tipoEmpresa').value !==
                                'Juridica'
                            "
                            (click)="seleccionarTipoEmpresa('Juridica')">
                            ▢
                        </button>
                        <button
                            class="btn_tipo btn_add"
                            *ngIf="
                                empresaForm.get('tipoEmpresa').value ===
                                'Juridica'
                            "
                            (click)="seleccionarTipoEmpresa('Juridica')">
                            ▣
                        </button>
                    </div>
                </div>
            </div>
            <div
                *ngIf="
                    empresaForm.get('tipoEmpresa').hasError('required') &&
                    empresaForm.get('tipoEmpresa').touched
                ">
                <p class="empresa_error-checkbox">
                    Debe seleccionar el tipo de empresa.
                </p>
            </div>

            <label
                class="text-label"
                for="tipo_producto_que_importa"
                style="margin-top: 1rem">
                3. Tipo de producto
                <sup class="text-danger">*</sup>
            </label>
            <div class="container_tipo_producto eslabon-item">
                <div *ngFor="let opcion of opcionesProducto; let i = index">
                    <span>{{ '3.' + (i + 1) }}</span>
                    <span>{{ etiquetaProducto(opcion) }}</span>
                    <button
                        class="btn_tipo btn_remove"
                        *ngIf="!selectedProductos.includes(opcion)"
                        (click)="addProducto(opcion)"
                        [disabled]="!asociarView">
                        ▢
                    </button>
                    <button
                        class="btn_tipo btn_add"
                        *ngIf="selectedProductos.includes(opcion)"
                        (click)="removeProducto(opcion)"
                        [disabled]="!asociarView">
                        ▣
                    </button>
                </div>
            </div>
            <div
                *ngIf="
                    (empresaForm
                        .get('tipo_producto_que_importa')
                        .hasError('required') &&
                        empresaForm.get('tipo_producto_que_importa').touched) ||
                    (selectedProductos.length === 0 &&
                        empresaForm.get('eslabon').touched)
                ">
                <p class="empresa_error-checkbox">
                    El tipo de producto es obligatorio.
                </p>
            </div>

            <div class="label-with-tooltip">
                <label class="text-label" for="eslabon">
                    4. Eslabón
                    <sup class="text-danger">*</sup>
                </label>
                <button
                    type="button"
                    class="btn btn-outline-success rounded-circle p-0 tooltip-icon-btn"
                    (click)="mostrarTooltipEslabon()">
                    <i class="fas fa-question"></i>
                </button>
            </div>
            <div class="eslabon-grid-container">
                <ng-container
                    *ngFor="let opcion of opcionesEslabon; let i = index">
                    <div
                        class="eslabon-item"
                        *ngIf="
                            (opcion !== 'Empacador' &&
                                opcion !== 'Envasador') ||
                            mostrarEslabonesSecundarios
                        ">
                        <span>{{ '4.' + (i + 1) }}</span>
                        <span>{{ opcion }}</span>
                        <button
                            class="btn_tipo btn_remove"
                            *ngIf="!selectedEslabon.includes(opcion)"
                            (click)="addEslabon(opcion)"
                            [disabled]="
                                !asociarView ||
                                ((opcion === 'Empacador' ||
                                    opcion === 'Envasador') &&
                                    !selectedEslabon.includes('Productor') &&
                                    !selectedEslabon.includes(
                                        'Comercializador'
                                    ) &&
                                    !selectedEslabon.includes('Importador'))
                            ">
                            ▢
                        </button>
                        <button
                            class="btn_tipo btn_add"
                            *ngIf="selectedEslabon.includes(opcion)"
                            (click)="removeEslabon(opcion)"
                            [disabled]="!asociarView">
                            ▣
                        </button>
                    </div>
                </ng-container>
            </div>
            <div
                *ngIf="
                    (empresaForm.get('eslabon').hasError('required') &&
                        empresaForm.get('eslabon').touched) ||
                    (selectedEslabon.length === 0 &&
                        empresaForm.get('eslabon').touched)
                ">
                <p class="empresa_error-checkbox">
                    El tipo de eslabón es obligatorio.
                </p>
            </div>

            <!-- Bloque 5: Nit empresa -->
            <div class="container_nit_empresa">
                <div>
                    <div class="container_digito_nit">
                        <div class="form-control">
                            <label class="text-label" for="nit">
                                5. Nit empresa:
                                <sup class="text-danger">*</sup>
                            </label>
                            <input type="text" formControlName="nit" />
                        </div>
                        <div
                            style="
                                position: relative;
                                top: 25px;
                                margin-left: 0.3rem;
                            ">
                            -
                        </div>
                        <div class="form-control">
                            <label for="digito_verificacion">
                                5.1 DV
                                <sup class="text-danger">*</sup>
                            </label>
                            <input
                                style="width: 40px; text-align: center"
                                type="number"
                                formControlName="digito_verificacion" />
                        </div>
                    </div>
                    <div
                        *ngIf="
                            empresaForm.get('nit').hasError('required') &&
                            empresaForm.get('nit').touched
                        ">
                        <p class="error-message">El nit es obligatorio.</p>
                    </div>
                    <div
                        *ngIf="
                            empresaForm.get('nit').hasError('pattern') &&
                            empresaForm.get('nit').touched
                        ">
                        <p class="error-message">
                            El nit debe tener entre 6 y 10 caracteres.
                        </p>
                    </div>
                    <div
                        *ngIf="
                            empresaForm
                                .get('digito_verificacion')
                                .hasError('required') &&
                            empresaForm.get('digito_verificacion').touched
                        ">
                        <p class="error-message">
                            El dígito de verificación es obligatorio.
                        </p>
                    </div>
                    <div
                        *ngIf="
                            empresaForm
                                .get('digito_verificacion')
                                .hasError('pattern') &&
                            empresaForm.get('digito_verificacion').touched
                        ">
                        <p class="error-message">
                            El número de verificación solo tiene un dígito
                            numérico.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Bloque 6: Nombre o razón social -->
            <div class="form-control">
                <label class="text-label" for="razonSocial">
                    6. Nombre o razón social:
                    <sup class="text-danger">*</sup>
                </label>
                <input
                    type="text"
                    formControlName="razonSocial"
                    (input)="toUpperCase($event, 'razonSocial')" />
            </div>
            <div
                *ngIf="
                    empresaForm.get('razonSocial').hasError('required') &&
                    empresaForm.get('razonSocial').touched
                ">
                <p class="error-message">
                    El nombre o razón social es obligatorio.
                </p>
            </div>
            <br />
            <br />
            <!-- Bloque 7: Nombre del responsable de la información / Representante Legal -->
            <div class="form-control">
                <label class="text-label" for="responsableInformacion">
                    7. Nombre del responsable de la información / Representante
                    Legal:
                    <sup class="text-danger">*</sup>
                </label>
                <input type="text" formControlName="responsableInformacion" (input)="toUpperCase($event, 'responsableInformacion')"/>
            </div>
            <div
                *ngIf="
                    empresaForm
                        .get('responsableInformacion')
                        .hasError('required') &&
                    empresaForm.get('responsableInformacion').touched
                ">
                <p class="error-message">
                    El nombre del responsable de la información / Representante
                    Legal es obligatorio.
                </p>
            </div>
            <br />
            <br />
            <!-- Bloque 8: Correo electrónico -->
            <div class="form-control">
                <label class="text-label" for="correo_corporativo">
                    8. Correo electrónico del responsable de la información /
                    Representante Legal:
                    <sup class="text-danger">*</sup>
                </label>
                <input type="text" formControlName="correo_corporativo" />
            </div>
            <div
                *ngIf="
                    empresaForm
                        .get('correo_corporativo')
                        .hasError('required') &&
                    empresaForm.get('correo_corporativo').touched
                ">
                <p class="error-message">
                    El correo electrónico es obligatorio.
                </p>
            </div>
            <div
                *ngIf="
                    empresaForm.get('correo_corporativo').hasError('email') &&
                    empresaForm.get('correo_corporativo').touched &&
                    !empresaForm.get('correo_corporativo').hasError('required')
                ">
                <p class="error-message">
                    El formato del correo electrónico no es válido.
                </p>
            </div>
            <br />
            <br />
            <ng-template #elseBlock>
                <button
                    class="styles_btn-accept empresa_btn-enviar"
                    (click)="asociarEmpresa()">
                    Asociar y continuar
                </button>
            </ng-template>
        </div>
        <!-- Fin columna izquierda -->

        <!-- ======================================================= -->
        <!-- COLUMNA DERECHA con su nueva clase específica -->
        <!-- ======================================================= -->
        <div class="empresa_conteiner-colum columna-derecha">
            <!-- Bloque 9: Cargo -->
            <div class="form-control">
                <label class="text-label" for="cargoDependencia">
                    9. Cargo/Dependencia de la persona responsable de la
                    información:
                    <sup class="text-danger">*</sup>
                </label>
                <select formControlName="cargoDependencia" class="form-group">
                    <option [ngValue]="null" [selected]="true">
                        Seleccione un cargo/dependencia
                    </option>
                    <option
                        *ngFor="let cargo of cargos"
                        [ngValue]="cargo.nombre">
                        {{ cargo.nombre }}
                    </option>
                </select>
            </div>
            <div
                *ngIf="
                    empresaForm.get('cargoDependencia').hasError('required') &&
                    empresaForm.get('cargoDependencia').touched
                ">
                <p class="error-message">
                    El cargo/dependencia es obligatorio.
                </p>
            </div>
            <br />
            <br />

            <!-- Bloque 10: Teléfono -->
            <div class="form-control">
                <label class="text-label" for="telefono">
                    10. Teléfono:
                    <sup class="text-danger">*</sup>
                </label>
                <input type="number" formControlName="telefono" />
            </div>
            <div
                *ngIf="
                    empresaForm.get('telefono').hasError('required') &&
                    empresaForm.get('telefono').touched
                ">
                <p class="error-message">El teléfono es obligatorio.</p>
            </div>
            <div
                *ngIf="
                    empresaForm.get('telefono').hasError('pattern') &&
                    empresaForm.get('telefono').touched
                ">
                <p class="error-message">
                    El teléfono debe tener 10 caracteres.
                </p>
            </div>
            <br />
            <br />

            <!-- Bloque 11: Departamento -->
            <div class="form-control">
                <label class="text-label" for="departamento">
                    11. Departamento:
                    <sup class="text-danger">*</sup>
                </label>
                <select
                    formControlName="departamento"
                    class="form-group"
                    (change)="updateMunicipio()">
                    <option [ngValue]="null" [selected]="true">
                        Seleccione un departamento
                    </option>
                    <option
                        *ngFor="let departament of departamentos"
                        [ngValue]="departament.id">
                        {{ departament.nombre }}
                    </option>
                </select>
            </div>
            <div
                *ngIf="
                    empresaForm.get('departamento').hasError('required') &&
                    empresaForm.get('departamento').touched
                ">
                <p class="error-message">El departamento es obligatorio.</p>
            </div>
            <br />
            <br />

            <!-- informacion lara la direccion urbana -->

            <!--   --------------------------------------------   -->

            <app-dir-urbana
                #dirUrbana
                (direccionUrbanaChanged)="
                    onDireccionUrbanaChanged($event)
                "></app-dir-urbana>

            <button
                (click)="submitForm()"
                class="styles_btn-accept empresa_btn-enviar"
                *ngIf="asociarView; else elseBlock">
                Guardar y continuar
            </button>
        </div>
    </div>
</form>
